import { FormGroup } from '@angular/forms';
import { GenericValidator } from './generic-validator';

export class FormConfig {
  formGroup: FormGroup;
  displayMessage: { [key: string]: string } = {};
  genericValidator: GenericValidator;
}
